<template>
  <div class="main">
    <el-dialog
      title="修改服务类型"
      :visible.sync="openData.state"
      :close-on-click-modal="false"
      width="700px"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="content">
        <el-tree
          :data="treeData"
          show-checkbox
          default-expand-all
          :default-checked-keys="checkIds"
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
        >
        </el-tree>
      </div>
      <div slot="footer" class="dialog-footer dialog-footer-btn">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialogVisibleClone">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["openData"],
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "serviceTypeName",
      },
      treeData: [],
      childrendata: [],
      checkIds: [],
    }
  },
  created() {
    this.getData()
    //获取子列表
    this.$http
      .request({
        url: "/jjyl/admin/product/info/findList",
        method: "POST",
        data: { pageSize: 100, pageNo: 1 },
      })
      .then((res) => {
        this.childrendata = res.content.list.map((item) => {
          item.children = []
          return item
        })
      })
  },
  methods: {
    // 获取数据
    getData() {
      this.$http
        .request({
          url: "/ypt/admin/serviceStation/info/findServetypeServestation",
          method: "POST",
          data: { serviceStationId: this.openData.id },
        })
        .then((res) => {
          if (res.code == 200) {
            res.content.forEach((item) => {
              this.checkIds.push(item.standardAddressId)
            })
            this.getTree()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 获取树
    getTree() {
      //获取父类别
      this.$http
        .request({
          url: "/jjyl/admin/type/info/findList",
          method: "POST",
          data: { pageSize: 100, pageNo: 1 },
        })
        .then((res) => {
          let arr = res.content.list.map((item) => {
            item.children = []
            return item
          })
          let arr1 = this.childrendata
          this.treeData = arr.filter((item) => {
            for (let i in arr1) {
              if (item.id == arr1[i].id) {
                arr1[i].serviceTypeName = arr1[i].serviceProductName
                item["children"].push(arr1[i])
              }
            }
            return item.children.length > 0
          })

          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.checkIds)
          })
        })
    },

    // 关闭
    dialogVisibleClone() {
      this.$emit("cancleChoose", false)
    },
    // 提交
    handleSubmit() {
      this.$http
        .request({
          url: "/ypt/admin/serviceStation/info/updateServetypeServestation",
          method: "POST",
          data: {
            serviceStationId: this.openData.id,
            serviceIds: this.$refs.tree.getCheckedKeys(),
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.$emit("cancleChoose", true)
            this.$refs.tree.setCheckedKeys([])
          } else {
            this.$message.error(res.message)
          }
        })
    },
  },
}
</script>
<style lang="less" scoped></style>
